export default "__VITE_ASSET__r82qMVgA__"